export const YOURS_COLOR = '#1982C4';
export const COMPETITOR_COLOR = '#EF6820';

export const RELATIONSHIPS = {
  strong: { label: 'Strong', color: 'success' },
  contested: { label: 'Contested', color: 'gray' },
  behind: { label: 'Behind', color: 'warning' },
  gap: { label: 'Gap', color: 'error' },
};

export const competitorShare = (row) => (row.yours + row.competitor ? row.competitor / (row.yours + row.competitor) : 0);

export const blendColor = (row) => `color-mix(in oklab, ${COMPETITOR_COLOR} ${Math.round(competitorShare(row) * 100)}%, ${YOURS_COLOR})`;

export const initials = (name) => (name || '')
  .replace(/^The /, '')
  .replace(/[^A-Za-z ]/g, '')
  .split(' ')
  .filter(Boolean)
  .slice(0, 2)
  .map((word) => word[0])
  .join('')
  .toUpperCase();

export const formatDate = (iso, options = { month: 'short', day: 'numeric', year: 'numeric' }) => (
  iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-US', options) : '—'
);

export const matchesSelection = (event, selection) => {
  if (!selection) return true;
  return selection.level === 'agency' ? event.agency === selection.key : event.agent_key === selection.key;
};

export const GRAPH = { width: 1000, height: 520, left: 210, right: 790 };

export function layoutNodes(rows, level) {
  const centerY = GRAPH.height / 2;
  const agencyLevel = level === 'agency';
  const nodes = rows
    .slice()
    .sort((a, b) => (b.yours + b.competitor) - (a.yours + a.competitor))
    .map((row, index) => {
      const total = row.yours + row.competitor;
      const radius = agencyLevel ? Math.min(30, 7 + Math.sqrt(total) * 2.6) : Math.min(18, 4.5 + Math.sqrt(total) * 2.1);
      const targetX = GRAPH.left + competitorShare(row) * (GRAPH.right - GRAPH.left);
      const side = index % 2 ? 1 : -1;
      return { ...row, total, radius, targetX, x: targetX, y: centerY + side * (Math.floor(index / 2) + 0.5) * (agencyLevel ? 34 : 18) };
    });
  const padding = agencyLevel ? 16 : 9;
  for (let iteration = 0; iteration < 260; iteration += 1) {
    for (let i = 0; i < nodes.length; i += 1) {
      for (let j = i + 1; j < nodes.length; j += 1) {
        const a = nodes[i];
        const b = nodes[j];
        let dx = b.x - a.x;
        let dy = b.y - a.y;
        const distance = Math.hypot(dx, dy) || 0.01;
        const minimum = a.radius + b.radius + padding;
        if (distance < minimum) {
          const push = (minimum - distance) / 2;
          dx /= distance;
          dy /= distance;
          a.x -= dx * push * 0.35;
          b.x += dx * push * 0.35;
          a.y -= dy * push;
          b.y += dy * push;
        }
      }
    }
    nodes.forEach((node) => {
      node.x += (node.targetX - node.x) * 0.12;
      node.y += (centerY - node.y) * 0.004;
      node.y = Math.max(46 + node.radius, Math.min(GRAPH.height - 34 - node.radius, node.y));
      node.x = Math.max(150, Math.min(850, node.x));
    });
  }
  return nodes;
}
